import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import cssUrl from '../components/cssUrl';

/** スタッフ1名分のカード。写真 → 役職 → 名前 → 資格タグ。 */
const StaffContainer = ({ photo, role, name, eng, link, shikaku = [] }) => {
  return (
    <Box>
      <Box
        sx={{
          aspectRatio: '4 / 3',
          backgroundImage: cssUrl(photo),
          backgroundSize: 'cover',
          backgroundPosition: 'center top',
          backgroundRepeat: 'no-repeat',
          bgcolor: 'kinari',
        }}
      />
      {role ? (
        <Typography
          sx={{ fontSize: 13, fontWeight: 500, letterSpacing: '.14em', color: 'green', mt: 3, mb: 0.75 }}
        >
          {role}
        </Typography>
      ) : null}

      <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1.75, flexWrap: 'wrap' }}>
        <Typography variant="h3" component="h2" sx={{ fontSize: { xs: 22, sm: 26 }, letterSpacing: '.16em' }}>
          {name}
        </Typography>
        <Typography
          component="span"
          sx={{ fontSize: 12, letterSpacing: '.18em', color: 'text.secondary', textTransform: 'uppercase' }}
        >
          {eng}
        </Typography>
        {link ? (
          <Box
            component="a"
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              fontSize: 13,
              letterSpacing: '.06em',
              ml: 'auto',
              color: 'green',
              textDecoration: 'none',
              '&:hover': { color: 'greenDeep' },
            }}
          >
            Instagram →
          </Box>
        ) : null}
      </Box>

      {shikaku.length > 0 ? (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 2 }}>
          {shikaku.map((item) => (
            <Box
              key={item}
              component="span"
              sx={{
                fontSize: 12.5,
                letterSpacing: '.06em',
                color: 'sumi',
                bgcolor: 'kinari',
                px: 1.75,
                py: 0.75,
              }}
            >
              {item}
            </Box>
          ))}
        </Box>
      ) : null}
    </Box>
  );
};

export default StaffContainer;
